import { StationMap } from "../../shared/components/station-map.component";
import { useMapEmbedParams } from "../use-map-embed-params";

export const MapPage: React.FC = () => {
  const { isEmbedded, stationSlug } = useMapEmbedParams();

  return <StationMap embedded={isEmbedded} stationSlug={stationSlug} />;
};
